module.exports = __webpack_public_path__ + "static/media/module-coach.323a0b33.png";